import React from "react";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../components/MaterialBox";
import { FormControl, FormHelperText } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
function Carryover({
  handleChange,
  togglePage,
  handleleaveconfigdataChange,
  leaveconfigdata,
}) {
  return (
    <MaterialBox>
      <Grid mt={4} container spacing={2}>
        <Grid ml={1}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Carry Over to Next Year
            </MaterialTypography>
          </MaterialBox>
          <FormControlLabel
            sx={{ marginLeft: "1%" }}
            control={
              <Switch
                checked={leaveconfigdata.carryover}
                onChange={(e) =>
                  handleleaveconfigdataChange({
                    target: {
                      name: "carryover",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
              />
            }
            label={leaveconfigdata.carryover ? "Yes" : "No"}
            disabled={togglePage.view === true ? true : false}
          />
        </Grid>

        <Grid ml={2} size={{ xs: 3.5, sm: 3.5 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Carry Over Limit 
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="carryoverlimit"
            onChange={handleChange}
            value={leaveconfigdata.carryoverlimit}
            error={leaveconfigdata.carryoverlimitStatus === "error"}
            success={leaveconfigdata.carryoverlimitStatus === "success"}
            disabled={togglePage.view === true || !leaveconfigdata.carryover}
          />
          {leaveconfigdata.carryoverlimitStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only Numbers maximum of two characters{" "}
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid ml={2}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Carry Over Expiry
            </MaterialTypography>
          </MaterialBox>
          <FormControlLabel
            sx={{ marginLeft: "1%" }}
            control={
              <Switch
                checked={leaveconfigdata.carryoverexpiry}
                onChange={(e) =>
                  handleleaveconfigdataChange({
                    target: {
                      name: "carryoverexpiry",
                      value: e.target.checked,
                    },
                  })
                }
                color="primary"
              />
            }
            label={leaveconfigdata.carryoverexpiry ? "Yes" : "No"}
            disabled={togglePage.view === true ? true : false}
          />
        </Grid>
        <Grid ml={2} size={{ xs: 3.5, sm: 3.5 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Expiry Limit in Days 
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="expirylimit"
            onChange={handleChange}
            value={leaveconfigdata.expirylimit}
            error={leaveconfigdata.expirylimitStatus === "error"}
            success={leaveconfigdata.expirylimitStatus === "success"}
            disabled={
              togglePage.view === true || !leaveconfigdata.carryoverexpiry
            }
          />
          {leaveconfigdata.expirylimitStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only Numbers maximum of two characters{" "}
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
      </Grid>
    </MaterialBox>
  );
}

export default Carryover;
